import { render } from "./VZSort.vue?vue&type=template&id=3ccea0c7&scoped=true&ts=true"
import script from "./VZSort.vue?vue&type=script&lang=ts"
export * from "./VZSort.vue?vue&type=script&lang=ts"

import "./VZSort.vue?vue&type=style&index=0&id=3ccea0c7&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ccea0c7"]])

export default __exports__